import React from 'react';
import TermsSection, { SectionText, BulletPoint } from './TermsSection';
import ContactInfo from './ContactInfo';

const AccessibilitySection = () => (
  <TermsSection title="4. Accessibility">
    <SectionText>
      Campus Insights strives to make its services accessible to all users, including those with disabilities. Please contact us with any accessibility questions or concerns.
    </SectionText>
  </TermsSection>
);

const ThirdPartySection = () => (
  <TermsSection title="5. Third-Party Tools">
    <SectionText>Campus Insights may use vetted third-party service providers for:</SectionText>
    <BulletPoint>• Infrastructure and hosting</BulletPoint>
    <BulletPoint>• System monitoring and uptime</BulletPoint>
    <BulletPoint>• Security and encryption</BulletPoint>
    <SectionText>No personal data is shared with third parties.</SectionText>
  </TermsSection>
);

const IntellectualPropertySection = () => (
  <TermsSection title="6. Intellectual Property">
    <SectionText>
      Campus Insights retains ownership of all software, models, and design assets. Users may not reuse or redistribute platform elements outside their intended educational purpose without written permission.
    </SectionText>
  </TermsSection>
);

const PlatformAvailabilitySection = () => (
  <TermsSection title="7. Platform Availability & Accuracy">
    <SectionText>We aim to provide reliable service but do not guarantee that:</SectionText>
    <BulletPoint>• Responses will always be accurate or complete</BulletPoint>
    <BulletPoint>• Access will be uninterrupted or error-free</BulletPoint>
    <SectionText>
      Campus Insights is not responsible for decisions made based on AI-generated responses.
    </SectionText>
  </TermsSection>
);

const AIExplainabilitySection = () => (
  <TermsSection title="8. AI Explainability & Human Oversight">
    <SectionText>
      AI-powered responses are subject to monitoring and human review. High-impact or sensitive decisions are never made by AI alone.
    </SectionText>
  </TermsSection>
);

const TerminationSection = () => (
  <TermsSection title="9. Termination">
    <SectionText>Campus Insights may restrict or terminate access if:</SectionText>
    <BulletPoint>• These Terms are violated</BulletPoint>
    <BulletPoint>• The institutional agreement ends</BulletPoint>
    <BulletPoint>• Required by law or for system security</BulletPoint>
  </TermsSection>
);

const JurisdictionSection = () => (
  <TermsSection title="10. Jurisdiction & Dispute Resolution">
    <SectionText>
      These Terms are governed by the laws of [Insert Jurisdiction]. Any disputes will be handled by the courts of [Insert Jurisdiction].
    </SectionText>
  </TermsSection>
);

const UpdatesSection = () => (
  <TermsSection title="11. Updates to These Terms">
    <SectionText>
      We may update these Terms from time to time. Your continued use of Campus Insights indicates acceptance of any changes posted on our website.
    </SectionText>
  </TermsSection>
);

const ContactSection = () => (
  <TermsSection title="11. Contact Us">
    <ContactInfo />
  </TermsSection>
);

export {
  AccessibilitySection,
  ThirdPartySection,
  IntellectualPropertySection,
  PlatformAvailabilitySection,
  AIExplainabilitySection,
  TerminationSection,
  JurisdictionSection,
  UpdatesSection,
  ContactSection
};
